import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=140afc2c&scoped=true&"
import script from "./Device.vue?vue&type=script&lang=js&"
export * from "./Device.vue?vue&type=script&lang=js&"
import style0 from "./Device.vue?vue&type=style&index=0&id=140afc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140afc2c",
  null
  
)

export default component.exports